import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { LevelChangerThing } from "./levelChangerThing";

export class LevelUp extends LevelChangerThing {
	static key = "LevelUp";
	constructor(xy: XY, destinationLevel: number) {
		super(xy, destinationLevel);
	}

	static deserialize(data: any): LevelUp {
		const l = new LevelUp(deserializeXY(data.xy), data.destinationLevel);
		l.visualId = data.visualId;
		return l;
	}
}
